//import Task from "./Task"

import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ReactQuill from 'react-quill'

const StudentReportsList = ({tasks}) => {


    const {groupId} = useParams()
    if(!tasks.length  ) return <h1> אין נתונים להצגה</h1>
    const taskWithoutRatio = tasks.filter(task=>!task.ratio)
    const totalOfRatio = tasks.reduce((accumulator, task) => {
        return accumulator + (task.ratio? task.ratio:0) ;
      }, 0);

    const autoRatio = taskWithoutRatio.length? (100-totalOfRatio)/taskWithoutRatio.length:0
    const tableRow = (<>
     

    {tasks.map((task)=>{
        //console.log(task)
        let total =0;
        let countAction =task.actions.length;
        let actionWithRatio = 0
        const ratioHelper =  task.actions.reduce((rat,action)=>{
            if(action.ratio) actionWithRatio++;
            return action.ratio? rat+action.ratio : rat
         
        }, 0)



        task.actions.map(action=>{
            const res =  task.responses.find(response=>response.action===action._id)
            if(res && res.grade > -1){
                if(action.ratio){
                    total += res.grade * action.ratio / 100
                }else if(ratioHelper){
                    if(countAction-  actionWithRatio<=0 || ratioHelper > 100){ //שגיאה בגלל שהפעולות יותר מ100%
                        total+= res.grade / countAction 
                    }
                    else{
                        total+= res.grade  *( (100-ratioHelper)/ (countAction-  actionWithRatio)) /100

                    }
                }else{
                    total+= res.grade  / countAction
                }
                         
            }
        })
        return <tr key={task._id}  className="table__row">
            <td className="table__cell "> {task.title}</td>
            {/* <td  className="table__cell ">
                <div className='quill-max-height-250 quill-min-height-250'>
                 <ReactQuill
                     theme='bubble'
                    readOnly
                    value={task.body}
                    
                    ></ReactQuill> 
                </div>
                </td> */}
            <td className="table__cell ">{task.ratio? `${task.ratio}%`:`${autoRatio.toFixed(2)}%` }</td>
            <td className="table__cell ">{( total > 100? 100: total).toFixed(2)}</td>
        </tr>
      
       
       
    })}
   
        
    </>)

      const  content = (
            <>
            <h2>*המשקל אינו סופי כי לא כולל את השאלונים</h2>
            <table className={`table table--student-reports `} >
                <thead className="table__thead">
                    <tr>


                        <th scope="col" className="table__th task__title"> משימה</th>
                        {/* <th scope="col" className="table__th task__body">תוכן המשימה</th> */}
                        <th scope="col" className="table__th task__body"> משקל </th>
                        <th scope="col" className="table__th task__body"> ציון</th>

                    </tr>
                   
                </thead>

                <tbody>
              {tableRow}
                </tbody>
            </table>
            </>
        )
  

    return content
}
export default StudentReportsList